module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row footerBackgroudColor"
  }, [_c('div', {
    staticClass: " col-md-12 divCenterOne"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: " col-md-4 col-md-offset-4 divLanguageClassTwo",
    staticStyle: {
      "font-size": "20px"
    }
  }, [_c('div', {
    staticClass: "divLanguageClass"
  }, [_c('span', {
    staticClass: "spanGrowClass"
  }), _vm._v(" "), _c('span', {
    staticClass: "developer_footer_language "
  }, [_vm._v(_vm._s(_vm.$t('language')))]), _vm._v(" "), _c('div', {
    staticClass: "divInputImageClass",
    attrs: {
      "inputDomClick": true
    }
  }, [_c('input', {
    staticClass: "rectangle_4",
    class: _vm.styleDisplay ? 'rectangle_4_true' : '',
    attrs: {
      "inputDomClick": true,
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.languageChoose
    },
    on: {
      "click": _vm.clickDivFunc
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "selectImage",
    attrs: {
      "inputDomClick": true,
      "src": require("../../../static/img/account/selectImage.png"),
      "alt": ""
    },
    on: {
      "click": _vm.clickDivFunc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "positionSelect",
    style: (_vm.styleDisplay ? 'display:block' : 'display:none'),
    attrs: {
      "inputDomClick": true
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.chineseFTColor),
      expression: "!chineseFTColor"
    }],
    staticClass: "chineseFTColor",
    attrs: {
      "inputDomClick": true
    },
    on: {
      "click": function($event) {
        _vm.$_admin_dash_change_lang('zh-TW')
      }
    }
  }, [_vm._v("繁體中文")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.chineseJTColor),
      expression: "!chineseJTColor"
    }],
    staticClass: "chineseJTColor",
    attrs: {
      "inputDomClick": true
    },
    on: {
      "click": function($event) {
        _vm.$_admin_dash_change_lang('zh-CN')
      }
    }
  }, [_vm._v("简体中文")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 divCenterOneImage divCenterOneImagePadding"
  }, [_c('div', {
    staticClass: " col-md-8 "
  }, [_c('span', {
    staticClass: "developer_footer_resources"
  }, [_vm._v(_vm._s(_vm.$t('resources')))]), _vm._v(" "), _c('span', {
    staticClass: "developer_footer_support "
  }, [_vm._v(_vm._s(_vm.$t('support')))]), _vm._v(" "), _c('span', {
    staticClass: "developer_footer_about_nuwa"
  }, [_vm._v(_vm._s(_vm.$t('aboutNuwa')))])]), _vm._v(" "), _c('div', {
    staticClass: " col-md-4  divCenterImageClassOne"
  }, [_c('div', {
    staticClass: "divCenterOneImagesClass"
  }, [_c('span', {
    staticClass: "spanGrowClass"
  }), _vm._v(" "), _c('img', {
    staticClass: "facebookImage",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "src": require("../../../static/img/account/facebook.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.imageClickFunc('facebook')
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "youtubeImage",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "src": require("../../../static/img/account/youtube.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.imageClickFunc('youtube')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "wechatImagePosition",
    style: (_vm.wechatStyle)
  }, [_c('span', {
    staticClass: "spanPosition"
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "86px",
      "height": "86px",
      "cursor": "pointer"
    },
    attrs: {
      "src": require("../../../static/img/account/wechat_qr_code.png")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.imageClickFunc('wechat')
      }
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "wechatImage",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "src": require("../../../static/img/account/wechat.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.imageClickFunc('wechat')
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: " col-md-12"
  }, [_c('div', {
    staticClass: " col-md-8 developer_footer_div_class"
  }, [_c('div', {
    staticClass: "developer_footer_resources_div_class"
  }, [_c('ul', {
    staticClass: "ul_one ul_one_width"
  }, [_c('li', {
    staticClass: "developer_footer_resources_design_guideline",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.isFileFunc('design')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('designGuideilnes')))])]), _vm._v(" "), _c('li', {
    staticClass: "developer_footer_resources_design_guideline margin_li",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.isFileFunc('sdk')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('nuwaRobotSDK')))])]), _vm._v(" "), _c('li', {
    staticClass: "developer_footer_resources_design_guideline",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.isFileFunc('motion')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('motionList')))])])]), _vm._v(" "), _c('ul', {
    staticClass: "ul_one ul_marin"
  }, [_c('li', {
    staticClass: "developer_footer_resources_design_guideline",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.isFileFunc('forums')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('forums')))])]), _vm._v(" "), _c('a', {
    staticClass: "developer_footer_resources_design_guideline margin_li",
    attrs: {
      "href": _vm.contact
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('bugReport')))])]), _vm._v(" "), _c('a', {
    staticClass: "developer_footer_resources_design_guideline",
    attrs: {
      "href": _vm.contact
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('contactUs')))])])]), _vm._v(" "), _c('ul', {
    staticClass: "ul_one"
  }, [_c('li', {
    staticClass: "developer_footer_resources_design_guideline",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.isFileFunc('home')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('nuwaHompage')))])]), _vm._v(" "), _c('li', {
    staticClass: "developer_footer_resources_design_guideline margin_li",
    style: (_vm.chineseFTColor ? 'cursor: pointer;' : ''),
    on: {
      "click": function($event) {
        _vm.isFileFunc('job')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('jobOpportunities')))])]), _vm._v(" "), _c('li', {
    staticClass: "developer_footer_resources_design_guideline",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.isFileFunc('buy')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('buyNUWARobot')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: " col-md-12 divCenterOneImagePaddingAll"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: " col-md-6 divCenterOneImagePaddingLeft"
  }, [_c('div', {
    staticClass: "developer_footer_about_div"
  }, [_c('span', {
    staticClass: "spanGrowClass"
  }), _vm._v(" "), _c('a', {
    staticClass: "developer_footer_about_nuwa_terms_and_agreements ",
    attrs: {
      "href": _vm.terms
    }
  }, [_vm._v(_vm._s(_vm.$t('termsAndAgreements')))]), _vm._v(" "), _c('span', {
    staticClass: "layer"
  }, [_vm._v("|")]), _vm._v(" "), _c('a', {
    staticClass: "developer_footer_privacy_policy",
    attrs: {
      "href": _vm.pricacy
    }
  }, [_vm._v(_vm._s(_vm.$t('privacyPolicy')))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " col-md-4 divCenterOneImage"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/account/developerNew.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " col-md-6 divCenterOneImage"
  }, [_c('p', {
    staticClass: "developer_footer_copyright"
  }, [_vm._v("Copyright © 2018 Nuwa Robotics. All rights reserved.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65c8b9b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/FooterIndex.vue
// module id = 1496
// module chunks = 1